/**
 * @link https://mui.com/material-ui/react-pagination/
 */

import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureePagination() {
  return (
    <>
      <Stack spacing={2}>
        <Pagination count={10} />
        <Pagination count={10} color="primary" />
        <Pagination count={10} color="secondary" />
        <Pagination count={10} disabled />
      </Stack>
      
      <ShowCode 
        codeString={`function PaginationExample() {
  return (
    <Stack spacing={2}>
      {/* Default pagination */}
      <Pagination count={10} />
      
      {/* Primary color pagination */}
      <Pagination count={10} color="primary" />
      
      {/* Secondary color pagination */}
      <Pagination count={10} color="secondary" />
      
      {/* Disabled pagination */}
      <Pagination count={10} disabled />
    </Stack>
  );
}`} 
        scope={{ 
          React, 
          Pagination, 
          Stack 
        }} 
      />
    </>
  );
}